import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import categoryService from "@/services/category.service"; // Ajuste para categorias
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveCategoryReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCategory = (): UseRemoveCategoryReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (categoryId) => categoryService.delete(categoryId),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};
export default useRemoveCategory;
